import { createRouter, RouterProvider } from '@tanstack/react-router';
import { Providers } from './providers';
import { routeTree } from '@/shared/generated/route-tree';

export const router = createRouter({ routeTree });

export function App() {
  return (
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  );
}
